// extracted by mini-css-extract-plugin
export default {"privacyPolicyNote":"style_privacyPolicyNote__OYK1K"};